import { cloudChiprApi } from "../../../services/cloudchipr.api";

export const getUsersMeCurrentPreferenceByKey =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select;
